import { Certificate } from '@legacy-types';

import { api } from '@shared/api/api';

export const getCertificates = api.createIndex<Certificate>('certificates');
